import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Tooltip from '@material-ui/core/Tooltip';
import { CSVLink } from 'react-csv';
import {
  RENT_CANCEL,
  RENT_ENDED,
  RENT_EXTENDED,
  RENT_IN_PROGRESS,
} from '../../constants/RentStates';
import KobooTablePagination from '../Layout/KobooTablePagination.jsx';
import { ROLE_ADMIN, ROLE_USER } from '../../constants/roles';
import RentRow from '../Rent/RentRow';
import StringService from "../../services/StringService";

/* eslint-disable no-bitwise */

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
  fabProgress: {
    color: 'primary',
    position: 'absolute',
    top: -6,
    left: -6,
    zIndex: 1,
  },
});

export function sec2str(t) {
  const d = Math.floor(t / 86400);
  const h = (`0${Math.floor(t / 3600) % 24}`).slice(-2);
  const m = (`0${Math.floor(t / 60) % 60}`).slice(-2);
  const s = (`0${t % 60}`).slice(-2);
  return (d > 0 ? `${d} jours ` : '')
    + (h > 0 ? `${h}h` : '')
    + (m > 0 ? `${m}m` : '')
    + (t > 60 ? s : `${s}s`);
}

export class LateRentTable extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      order: 'asc',
      orderBy: 'start_date',
      data: [],
      page: 0,
      rowsPerPage: 500,
      role: ROLE_USER,
    };
  }

  static sort(a, b, property, order) {
    const prop1 = (a[property] !== null && a[property] !== undefined) ? a[property] : -1;
    const prop2 = (b[property] !== null && b[property] !== undefined) ? b[property] : -1;
    if (order === 'asc') {
      return prop1 > prop2 ? -1 : 1;
    }
    return prop1 < prop2 ? -1 : 1;
  }

  static setRentState = (rent) => {
    if (rent.end_date && (rent.rent_price === 0 || !rent.rent_price)) {
      rent.state = rent.next_rent_id ? RENT_EXTENDED : RENT_CANCEL;
    } else if (rent.end_date) {
      rent.state = RENT_ENDED;
    } else {
      rent.state = RENT_IN_PROGRESS;
    }
    return rent;
  };

  static getDerivedStateFromProps(props, state) {
    let newState = null;
    if (props.authUser && props.roles) {
      const role = props.roles[props.authUser.uid];
      newState = { ...newState, role };
    }
    if (props.rents) {
      const rentArray = [];
      props.rents.forEach((rent) => {
        const foundBike = props.bikes.find(bike => bike.id === rent.bike_id);
        rent.bikeNumber = foundBike.number;
        rent.renterName = props.renters
          .find(renter => renter.id === foundBike.renter_info_id).name;

        rent.siteName = '';
        if (rent.start_site) {
          rent.siteName = props.sites.find(site => site.id === rent.start_site.id).name;
        } else if (foundBike.site_id) {
          rent.siteName = props.sites.find(site => site.id === foundBike.site_id).name;
        }

        rentArray.push(LateRentTable.setRentState(rent));
      });
      newState = { ...newState,
        data: rentArray.sort((a, b) => LateRentTable.sort(a, b, state.orderBy, state.order)),
      };
    }
    return newState;
  }

  static propTypes = {
    classes: PropTypes.object.isRequired,
    rents: PropTypes.array.isRequired,
    bikes: PropTypes.array.isRequired,
    renters: PropTypes.array.isRequired,
    sites: PropTypes.array.isRequired,
  };

  createSortHandler = property => () => {
    const orderBy = property;
    let order = 'desc';
    if (this.state.orderBy === orderBy && this.state.order === order) {
      order = 'asc';
    }
    const data = this.state.data.sort((a, b) => LateRentTable.sort(a, b, orderBy, order));
    this.setState({ data, order, orderBy });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
  };

  datasForCSV = () => {
    let datas=[];
    for (let rent of this.props.rents) {
      let data= Object();
      data['Etat'] = rent.state;
      data['Date de debut'] = StringService.dateTimestampToString(new Date(rent.start_date))
        + ' ' + StringService.timeTimestampToString(new Date(rent.start_date))
        + ' ' + StringService.dayTimestampToString(new Date(rent.start_date));
      data['Prix'] = rent.rent_price / 100;
      data['Numero du Velo'] = rent.bikeNumber;
      if (this.state.role === ROLE_ADMIN) {
        data['Loueur'] = rent.renterName ;
      }
      data['Site'] = rent.siteName;
      data['Duree'] = sec2str((rent.end_date ?
        rent.end_date : new Date() / 1e3 | 0) - rent.start_date);
      data['Nom du client'] = rent.username;
      data['Stripe CautionId'] = rent.caution_stripe_id;
      data['Stripe RentId'] = rent.rent_stripe_id;

      datas.push(data);
    }
    return datas;
  };

  render() {
    const columnData = [
      {
        id: 'state', numeric: false, disablePadding: true, label: 'État',
      },
      {
        id: 'start_date', numeric: false, disablePadding: false, label: 'Date de début',
      },
      {
        id: 'rent_price', numeric: true, disablePadding: false, label: 'Prix',
      },
      {
        id: 'bike_id', numeric: true, disablePadding: false, label: 'Numéro du Vélo',
      },
      {
        id: 'renterName', numeric: false, disablePadding: false, label: 'Loueur',
      },
      {
        id: 'siteName', numeric: false, disablePadding: false, label: 'Site',
      },
      {
        id: 'duration', numeric: false, disablePadding: false, label: 'Durée',
      },
      {
        id: 'client_mail', numeric: false, disablePadding: false, label: 'Email',
      },
      {
        id: 'client_phone', numeric: false, disablePadding: false, label: 'Telephone',
      },
    ];

    if (this.state.role < ROLE_ADMIN) {
      columnData.splice(columnData.findIndex(column => column.id === 'renterName'), 1);
    }

    const { classes } = this.props;

    const {
      data, rowsPerPage, page, order, orderBy,
    } = this.state;
    if (Array.isArray(data) && data.length) {
      return (
        <div>
          <CSVLink
            filename={`locations-${new Date().getTime()}.csv`}
            data={this.datasForCSV()}
          >
            Récupérer au format CSV
          </CSVLink>
          <div className={classes.tableWrapper}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  {columnData.map(column => (
                    <TableCell
                      key={column.id}
                      padding={column.disablePadding ? 'none' : 'normal'}
                      sortDirection={orderBy === column.id ? order : false}>
                      <Tooltip
                        title="Trier"
                        placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                        enterDelay={300}>
                        <TableSortLabel
                          active={orderBy === column.id}
                          direction={order}
                          onClick={this.createSortHandler(column.id)}>
                          {column.label}
                        </TableSortLabel>
                      </Tooltip>
                    </TableCell>
                  ), this)}
                </TableRow>
              </TableHead>
              <TableBody>
                {data.slice(page * rowsPerPage, (page * rowsPerPage) + rowsPerPage).map(rent => (
                  <RentRow
                    key={rent.id}
                    rent={rent}
                  />
                ))}
              </TableBody>
            </Table>
          </div>
          <KobooTablePagination
            numberOfItems={data.length}
            rowsPerPage={rowsPerPage}
            label="Locations par page"
            page={page}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </div>
      );
    }
    return (
      <Typography variant="subtitle1">Aucune location</Typography>
    );
  }
}

function mapStateToProps(state) {
  return {
    authUser: state.users.authUser,
    roles: state.roles.content,
    sending: state.rents.sending,
  };
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(LateRentTable);



// WEBPACK FOOTER //
// ./src/components/Dashboard/LateRentTable.jsx